<template>
  <el-select ref="Select" :value="innerName" style="width: 100%;" filterable :disabled="disabled" :filter-method="myFilterMethod" :placeholder="placeholder">
    <div slot="empty">
      <div v-infinite-scroll="load" style="overflow-y:auto;overflow-anchor:none;max-height:500px">
        <el-table :data="list" border :row-class-name="tableRowClassName" @cell-click="cellClick" style="max-width:900px" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template v-for="(item) in columns">
            <el-table-column show-overflow-tooltip :prop="item.key" width="120" :label="item.label" :key="item.label"></el-table-column>
          </template>
        </el-table>
        <div class="tip" v-loading="loading" v-if="loading">加载中...</div>
        <div class="tip" v-if="noMore">没有更多了...</div>
      </div>
    </div>
  </el-select>
</template>

<script>

import { Debounce } from '@/utils/utils'

export default {
  name: 'SelectScrollTable',
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default () {
        return;
      }
    },
    // dataList: {
    //   type: Array,
    //   default () {
    //     return []
    //   }
    // },
    innerName: {
      type: String,
      default () {
        return ''
      }
    },
    placeholder: {
      type: String,
      default () {
        return '请选择'
      }
    },
    filterMethod: {
      type: Function,
      default () {
        return {}
      }
    },
    otherQuery: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      query: {
        pageSize: 20,
        pageIndex: 1,
        keyWord: ''
      },
      totalCount: 1,
      totalPage: 1,
      list: [],
      loading: false,
      noMore: false
    }
  },
  mounted () {
    this.reset()
    this.getData()
  },
  beforeDestroy () {
  },
  computed: {
  },
  methods: {

    /**
     * 1、检索方法传进来
     * 2、页数内部定义
     * 3、滚动自增页数，检索，追加结果
     * 4、搜索，重置页数，重新检索
    */

    // 样式
    tableRowClassName ({ row, rowIndex }) {
      if (row.id === this.value) {
        return 'select-row';
      }
      return '';
    },
    cellClick (row, column, cell, event) {
      // this.$emit('input', row.id);
      this.$emit('change', row);
      this.$refs.Select.blur();
    },
    myFilterMethod: Debounce(function (val) {
      console.log(val, 'filtermethod')
      // this.$emit("filterMethod", val);
      this.query.keyWord = val
      this.query.pageIndex = 1
      this.reset()
      this.getData()
    }, 500),

    load () {
      if (this.query.pageIndex == this.totalPage) {
        this.noMore = true
        return
      }
      this.query.pageIndex += 1
      this.getData()
    },

    reset () {
      this.list = []
      this.noMore = false
      this.loading = false
      if (this.otherQuery) {
        for (var i in this.otherQuery) {
          this.query[i] = this.otherQuery[i]
        }
      }
    },

    getData () {
      this.loading = true
      this.filterMethod(this.query)
        .then((res) => {
          if (res.returnData.data) {
            res.returnData.data.map(item => {
              this.list.push(item)
            })
          }
          // this.list = res.returnData.data
          this.totalCount = res.returnData.totalCount
          this.totalPage = Math.ceil(this.totalCount / this.query.pageSize)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-table .select-row {
  background: #f0f9eb;
}
// div /deep/.el-table__body-wrapper {
//   // max-height: 348px !important;
// }
.tip {
  margin-left: 20px;
  color: #606166;
}
</style>
